<app-event-item-detail [eventItem]="eventItem" [btnView]="true" [btnClose]="true" (onCloseClicked)="onNoClick()" (onViewClicked)="onViewClick()">
</app-event-item-detail>
